import { dateDayWeeksBefore } from 'utils/dates';

const dataInfluences = [
  {
    investorType: 'Venture Capital',
    influence: 'Strategy Execution',
    count: 1,
    date: dateDayWeeksBefore(5, 5)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(5, 5)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Other',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Mutual Fund',
    influence: 'Profitability',
    count: 2,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Mutual Fund',
    influence: 'Cash-flow generation',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Mutual Fund',
    influence: 'Other',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Strategy Execution',
    count: 1,
    date: dateDayWeeksBefore(4, 5)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Cash-flow generation',
    count: 1,
    date: dateDayWeeksBefore(4, 5)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Strategy Execution',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Other',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'PE',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'PE',
    influence: 'Other',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    influence: 'Cash-flow generation',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    influence: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Holding Company',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Holding Company',
    influence: 'Cash-flow generation',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Strategy Execution',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'PE',
    influence: 'Strategy Execution',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'PE',
    influence: 'Other',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'PE',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },
  {
    investorType: 'PE',
    influence: 'Other',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },
  {
    investorType: 'SWF',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },
  {
    investorType: 'SWF',
    influence: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },
  {
    investorType: 'Mutual Fund',
    influence: 'Profitability',
    count: 2,
    date: dateDayWeeksBefore(2, 2)
  },
  {
    investorType: 'Mutual Fund',
    influence: 'Cash-flow generation',
    count: 1,
    date: dateDayWeeksBefore(2, 2)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Strategy Execution',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },
  {
    investorType: 'PE',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },
  {
    investorType: 'SWF',
    influence: 'Strategy Execution',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },
  {
    investorType: 'SWF',
    influence: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },
  {
    investorType: 'Hedge Fund',
    influence: 'Cash-flow generation',
    count: 1,
    date: dateDayWeeksBefore(1, 3)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Strategy Execution',
    count: 2,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Venture Capital',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Mutual Fund',
    influence: 'Strategy Execution',
    count: 2,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Mutual Fund',
    influence: 'Profitability',
    count: 2,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Corporate',
    influence: 'Strategy Execution',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    investorType: 'Holding Company',
    influence: 'Strategy Execution',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    investorType: 'Pension Fund',
    influence: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  },
  {
    investorType: 'Pension Fund',
    influence: 'Cash-flow generation',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  },
  {
    investorType: 'Corporate',
    influence: 'Strategy Execution',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  },
  {
    investorType: 'Corporate',
    influence: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  }
];

export default dataInfluences;
